module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Radio-b1f3bcd78d30a8ec99ec65da1cacfc7f.svg";